import React from 'react';
import { useParams } from 'react-router-dom';

import EntityLayout from '@/views/EntityLayout';
import ProcessSidebar from '@/views/ProcessSidebar/ProcessSidebar';

import ProcessHeader from './ProcessHeader';
import ProcessTalentsList from './ProcessTalentsList';

const LAYOUT_KEY = 'process';

const Process = () => {
  const { processId } = useParams();

  return (
    <EntityLayout
      header={<ProcessHeader processId={processId!} />}
      drawerContent={<ProcessSidebar processId={processId!} />}
      localStorageKey={LAYOUT_KEY}
      sx={{
        '& .EntityLayout-drawer--open': {
          minWidth: 412
        }
      }}
    >
      <ProcessTalentsList processId={processId!} />
    </EntityLayout>
  );
};

export default Process;
